"use client";
import { createContext, useContext } from "react";
import { FolderTreeItem } from "../structures/folderTree/useQueryFolderTree";

export const FolderContext = createContext<
  Omit<FolderTreeItem, "children"> | null | undefined
>(null);

export const useCurrentFolder = () => {
  const folder = useContext(FolderContext);

  if (!folder) {
    return null;
  }
  return folder;
};
